import React from "react";

const Paragraph = ({ children, className = "", underline = false }) => {
  return (
    <p
      className={`text-base text-black text-justify font-medium ${className} ${
        underline ? "underline" : ""
      }`}
    >
      {children}
    </p>
  );
};

export default Paragraph;
